import type { Product } from "./shop";

export interface User {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  phone: string | null;
  whatsapp: string;
  location: string;
  bio: string;
  display_name: string;
  is_staff: boolean;
  date_joined: string;
  email_notifications: boolean;
}

export interface Category {
  id: number;
  name: string;
  slug: string;
  kind: "furniture" | "fashion";
  parent: number | null;
  requires_document: boolean;
  attribute_definitions: {
    code: string;
    label: string;
    field_type: "text" | "number" | "select";
    required: boolean;
    options: string[];
  }[];
}

export interface Photo { id: number; image: string; position: number }

export interface Listing {
  id: number;
  slug: string;
  title: string;
  description: string;
  price: number;
  condition: string;
  brand: string;
  defects: string;
  location: string;
  attributes: Record<string, string | number>;
  article_count: number;
  category: number;
  category_name: string;
  category_slug: string;
  kind: "furniture" | "fashion";
  photos: Photo[];
  status: string;
  status_label: string;
  seller_name: string;
  is_favorite: boolean;
  favorite_count: number;
  published_at: string | null;
  expires_at: string | null;
}

export interface ListingDetail extends Listing {
  seller: { name: string; joined_at: string; location: string; bio: string };
  product: Product;
  document_checked: boolean;
  similar: Listing[];
}

export interface OwnerListing extends Listing {
  submission: number;
  instagram: string;
  home_photo: boolean;
  moderation_note: string;
  has_document: boolean;
  pending_revision: Record<string, unknown> | null;
  supplement_due: number;
  statistics: { views: number; contact_clicks: number; favorites: number; shares: number };
}

export interface Quote {
  grid_version: number;
  currency: string;
  lines: { publication: number; instagram: number; price: number }[];
  publication: number;
  discount_percent: number;
  discount: number;
  instagram: number;
  total: number;
  photo_estimate: number | null;
  photo_on_quote: boolean;
}

export interface Submission {
  id: number;
  listings: OwnerListing[];
  quote: Quote | null;
  submitted_at: string | null;
  invited_at: string | null;
  payment_deadline: string | null;
}

export interface Payment {
  id: string;
  submission: number;
  amount: number;
  status: string;
  is_test: boolean;
  provider?: string;
  payment_url?: string;
  order?: string | null;
  order_number?: string | null;
  invoice: { number: string; url: string } | null;
}

export interface CatalogFilters {
  q?: string;
  kind?: string;
  category?: string;
  min_price?: string;
  max_price?: string;
  condition?: string;
  location?: string;
  sort?: string;
  favorites?: string;
  page?: number;
}

export interface Page<T> { count: number; next: string | null; previous: string | null; results: T[] }

export const money = (amount: number) => new Intl.NumberFormat("fr-FR").format(amount) + " FCFA";
export const date = (value: string) => new Intl.DateTimeFormat("fr-FR", { dateStyle: "medium" }).format(new Date(value));
